import { use } from 'echarts/lib/echarts';
import { install } from './scatterGL/install';
use(install);